import styles from './W_PaymentSubscribePlanContent.module.css';
import W_PaymentCard from '../W_PaymentCard/W_PaymentCard';
import W_PaymentSubscribePlan from '../W_PaymentSubscribePlan/W_PaymentSubscribePlan';

export default function W_PaymentSubscribePlanContent() {
  return (
    <div className={styles.wrapper}>
      <W_PaymentCard />
      <W_PaymentSubscribePlan />
    </div>
  );
}
